import React, { useState, useCallback } from "react";
import styled, { ThemeProvider } from "styled-components";
import { FormattedMessage } from "react-intl";
import useOnClickOutside from "use-onclickoutside";
import withFluidWrapper from "./withFluidWrapper";

const Container = styled.section`
  position: relative;
  ${(p) => p.theme.minHeight && `min-height: ${p.theme.minHeight}`};
  ${(p) => p.theme.height && `height: ${p.theme.height}`};
  ${(p) => p.theme.maxHeight && `max-height: ${p.theme.maxHeight}`};

  // display:flex;
  transition: all 250ms ease;
  // background-color: ${(p) => (p.hover ? p.theme.colors.danger : "inherit")};

  background: white;
  border-radius: 5px;
  margin-bottom: 5px;
  padding-bottom: 5px;
  padding-top: 5px;

  padding-right: ${(p) => (p.fluid ? "55px !important" : "15px")};
  padding-left: ${(p) => (p.fluid ? "55px !important" : "15px")};

  &:before {
    content: "";
    display: ${(p) => (p.hover ? "block" : "none")};
    position: absolute;
    top: 0;
    right: ${(p) => (p.fluid ? "50px" : "0")};
    left: ${(p) => (p.fluid ? "50px" : "0")};
    bottom: 0;
    background-color: rgba(248, 215, 218, 0.6);
    z-index: 100;
  }

  height: ${(p) => p.theme.minHeight};
  //opacity:0.8;

  //z-index:10; // <-- this z-index is here because formBuilder has weired behaviours in view building.

  ${(p) => p.inlineCSS}
`;

const IconWrapper = styled.div`
  position: relative;
  width: 25px;
  height: 25px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 5px;

  transition: background-color 250ms ease;
  &:hover {
    background-color: #eee;
  }
`;

const RightCol = styled.div`
  padding-top: 5px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: ${(p) => (p.fluid ? "0px" : "-50px")};
  width: 50px;
  top: -2px;
  bottom: -2px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  border-top-right-radius: ${(p) => (p.fluid ? "0px" : "10px")};
  border-bottom-right-radius: ${(p) => (p.fluid ? "0px" : "10px")};
  font-family: Nunito;
  color: white;
  text-align: center;
  font-weight: 800;
  user-select: none;
  opacity: ${(p) => (p.fluid ? "0.8" : "1")};
  z-index: 5;
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
`;
const Center = styled.div``;
const Bottom = styled.div`
  padding-bottom: 0.3rem;
`;

const FakeContainer = styled.div`
  background-color: lightgrey;
  opacity: 0.5;
  min-height: 50px;
  margin-top: 25px;
  border-radius: 5px;
  border-color: grey;
  border-style: solid;

  border-widht: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 2rem;
`;

const Icon = styled.em`
  color: #777;
  font-size: 16px;
`;

const AddBtnWrapper = styled.div`
  padding-right: ${(p) => (p.fluid ? "50px" : "inherit")};
`;

const EditSection = (props) => {
  const {
    parentId,
    id,
    pageType,
    extra = {},
    save,
    children,
    label,
    select,
    selected,
    AddComponentButton,
    AddComponentPanel,
    RemoveComponentButton,
    add,
    componentsConfig,
    remove,
    rootId,
  } = props;

  const [hoverDelete, setHoverDelete] = useState(false);
  const [expand, setExpand] = useState(false);
  const [hover, setHover] = useState(true);

  const { fluid = false, style = {} } = extra;

  const thisAdd = useCallback((e) => {
    setExpand(false);
    add(e);
  }, []);

  const thisToggleFluid = useCallback(
    (e) => {
      save({ _id: id, key: "fluid", value: !fluid });
    },
    [fluid]
  );

  return (
    <ThemeProvider theme={style}>
      <Container
        fluid={fluid}
        className={extra.fluid ? "container-fluid px-0" : "container"}
        hover={hoverDelete}
        inlineCSS={extra.css}
        inlineStyle={style}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        selected={selected}
      >
        <RightCol
          fluid={extra.fluid}
          onClick={select}
          onDoubleClick={thisToggleFluid}
        >
          <Top>
            <IconWrapper
              data-id={id}
              data-parentid={rootId}
              onClick={remove}
              onMouseEnter={(e) => {
                e.stopPropagation();
                setHoverDelete(true);
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                setHoverDelete(false);
              }}
            >
              <Icon className="fal fa-trash" />
            </IconWrapper>
            <IconWrapper onClick={thisToggleFluid}>
              <Icon className="fal fa-arrows-alt-h" />
            </IconWrapper>
            <IconWrapper data-id={id} onClick={select}>
              <Icon className="fal fa-cog" />
            </IconWrapper>
          </Top>
          <Bottom>
            <AddComponentButton
              onClick={() => setExpand(!expand)}
              pageType={pageType}
              nodeType="Root"
              type="sibling"
              hoverIcon="fal fa-square"
              hoverLabel="Add section"
              componentsConfig={componentsConfig}
              id={id}
              add={add}
            />
          </Bottom>
        </RightCol>
        {children.length === 0 && (
          <AddComponentPanel
            show={hover}
            compact={true}
            onClick={() => setExpand(false)}
            pageType={pageType}
            nodeType="Section"
            type="child"
            hoverIcon="fal fa-square"
            hoverLabel="Add section"
            componentsConfig={componentsConfig}
            id={id}
            add={thisAdd}
          />
        )}
        {children}
      </Container>

      {expand && (
        <AddComponentPanel
          onClick={() => setExpand(false)}
          pageType={pageType}
          nodeType="Root"
          type="sibling"
          hoverIcon="fal fa-square"
          hoverLabel="Add section"
          componentsConfig={componentsConfig}
          id={id}
          add={thisAdd}
        />
      )}
    </ThemeProvider>
  );
};

export default withFluidWrapper(EditSection);
